

















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Button, Form, FormItem, Input, Message } from "element-ui";
import { axiosInstance } from "../../utils/axios";
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);

@Component({
    name: "ResetPassword",
})
export default class ResetPassword extends Vue {
    form = {
        newPass: "",
        checkPass: "",
        OTP: "",
    };
    disabledGetOtp = false;
    isLoading = false;

    async submitForm() {
        if (this.form.newPass !== this.form.checkPass) {
            throw Message({
                showClose: true,
                message: "Password doesn't match",
                type: "error",
            });
        }
        try {
            await axiosInstance.put("/user/reset-password", {
                otp: Number(this.form.OTP),
                password: this.form.newPass,
            });
            Message({
                showClose: true,
                message: "Change password successful",
                type: "success",
            });
            this.form.newPass = "";
            this.form.OTP = "";
            this.form.checkPass = "";
        } catch (e) {
            Message({
                showClose: true,
                message: e,
                type: "error",
            });
        }
    }
    async getOtp() {
        try {
            this.isLoading = true;
            await axiosInstance.get("/otp");
            Message({
                showClose: true,
                message: "An Otp mail has been sent to you",
                type: "success",
            });
            this.isLoading = false;
            this.disabledGetOtp = true;
        } catch (e) {
            Message({
                showClose: true,
                message: e,
                type: "error",
            });
        }
    }
}
